import { Component, OnInit } from '@angular/core';
import { ComponentModifyShipping } from '../component-modify-shipping';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ExpeditionsService } from '../../services/expeditions.service';
import { ErrorModalComponent } from '../../error-modal/error-modal.component';
import { ExpeditionModification } from '../../comun/recipient-services/expedition-modification';
import { Solution } from '../../comun/recipient-services/solutions/solution';
import { MessageModalComponent } from '../../message-modal/message-modal.component';
import { Expedition } from '../../comun/recipient-services/expedition';
import { NgForm } from '@angular/forms';
import { ExceptionHttp } from '../../services/api.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-confirm-solution-modal',
  templateUrl: './confirm-solution-modal.component.html',
  styleUrls: ['./confirm-solution-modal.component.css']
})
export class ConfirmSolutionModalComponent extends ComponentModifyShipping {
  constructor(
    private langService: LanguageService,
    public modal: BsModalRef
  ) {
    super();
  }
  zipCode: string;
  acceptPrivacyPolicy: boolean;

  change: Solution;


  get zipCodeMask(): string {
    return this.sesion.zipCodeMask;
  }

  async confirm(frm: NgForm) {
    try {
      const expedition = this.sesion.expedition$.getValue();
      if (!this.acceptPrivacyPolicy) {
        frm.controls.acceptPrivacyPolicy.markAsTouched();
        frm.controls.acceptPrivacyPolicy.setErrors({ 'politicaPrivacidad': this.langService.instant('ModifyDelivery.PrivacyPolicyInfo') }, { emitEvent: true })

      }
      if (frm.invalid) {
        return;
      }
      this.sesion.gaConfirmacion(this.change.type);

      const modification: ExpeditionModification = {
        TlgExpeditionNumber: expedition.TLGNumber,
        ExpeditionZipCode: this.zipCode,
        IncidenceNumber: expedition.IncidenceNumber,
        IncidenceAgencyCode: expedition.IncidenceAgencyCode,
        Changes: [this.change]
      }

      MessageModalComponent.show(await this.sesion.modify(modification));

      this.change.fillOutExpedition(this.sesion.expedition$.getValue());

      this.modal.hide();
    } catch (error) {
      const mistakeHttp = (error as ExceptionHttp);
      if (mistakeHttp && mistakeHttp.status == 400) {
        frm.controls.zipCode.markAsTouched();
        frm.controls.zipCode.setErrors({ 'zipCode': mistakeHttp.message }, { emitEvent: true })
      } else {
        ErrorModalComponent.show(error);
      }
    }
  }

}
